import { turbosSdk } from '@libs/turbos-sdk';
import {
  SuiClient,
  type SuiObjectDataOptions,
  type SuiObjectResponse,
  type DynamicFieldPage,
  type PaginatedObjectsResponse,
  type SuiObjectDataFilter,
} from '@mysten/sui/client';
import { unstable_getObjectFields } from 'turbos-clmm-sdk';

export async function forEacGetDynamicFields<T>(parentId: string): Promise<T[]> {
  let dynamicFields: DynamicFieldPage | undefined;
  let data: T[] = [];
  do {
    dynamicFields = await turbosSdk.provider.getDynamicFields({
      parentId: parentId,
      cursor: dynamicFields?.nextCursor,
      limit: 100,
    });
    if (dynamicFields) {
      data = [...data, ...(dynamicFields.data as T[])];
    }
  } while (dynamicFields.hasNextPage);

  return data;
}

export async function forEacGetOwnedObjects<T>(
  address: string,
  filter?: SuiObjectDataFilter,
): Promise<T[]> {
  let dynamicFields: PaginatedObjectsResponse | undefined;
  let data: T[] = [];
  do {
    dynamicFields = await turbosSdk.provider.getOwnedObjects({
      owner: address,
      cursor: dynamicFields?.nextCursor,
      options: { showContent: true, showType: true },
      filter: filter,
    });
    if (dynamicFields) {
      data = [
        ...data,
        ...(dynamicFields.data.map((item) => unstable_getObjectFields(item)) as T[]),
      ];
    }
  } while (dynamicFields.hasNextPage);

  return data;
}

export const multiGetObjects = async (
  provider: SuiClient,
  ids: string[],
  options?: SuiObjectDataOptions,
): Promise<SuiObjectResponse[]> => {
  const max = 50;
  const len = ids.length;
  if (len > max) {
    const requests = [];
    let i = 0;
    const times = Math.ceil(len / max);
    for (i; i < times; i++) {
      requests.push(
        provider.multiGetObjects({
          ids: ids.slice(i * max, (i + 1) * max),
          options,
        }),
      );
    }
    const response = await Promise.all(requests);
    return response.flat();
  }

  return await provider.multiGetObjects({
    ids,
    options,
  });
};
